import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

/**
 * Redirects the removed legacy organization detail route
 * (/admin/organizations/:orgId) to its Accounts replacement, preserving the id.
 */
const LegacyOrgDetailRedirect: React.FC = () => {
  const { orgId } = useParams<{ orgId: string }>();
  return <Navigate to={`/admin-next/accounts/organizations/${orgId}`} replace />;
};

export default LegacyOrgDetailRedirect;
